import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { customerGoogleSession } from "@/api";
import { useApp } from "@/context/AppContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginCustomer } = useApp();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const dest = sessionStorage.getItem("hg_post_auth_redirect") || "/account";
    sessionStorage.removeItem("hg_post_auth_redirect");
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    if (!sid) { navigate(dest); return; }
    customerGoogleSession(sid)
      .then(async (data) => { await loginCustomer(data); navigate(dest); })
      .catch(() => navigate(dest));
  }, [loginCustomer, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-paper" data-testid="auth-callback">
      <Loader2 className="h-8 w-8 animate-spin text-accent" />
    </div>
  );
}
